import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonSlides, IonImg, IonSlide, IonContent, IonSelect, IonSelectOption, IonLoading } from '@ionic/react';

//import { BookedRoomDetailsModal } from './Modal_DetailData_BookedRoom';
//import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { SelectDateRange_CheckIn } from './SelectDateRange_CheckIn';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import './Reservation_EnterBookingInfo_locals.css';
import { SelectDateRange_CheckIn } from './SelectDateRange_CheckIn_locals';
import { ShowRoomPicsModal } from './ShowRoomPicsModal_locals';

export function SelectRoom(props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    //let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    const [schema, setSchemaName] = useState(authMerchant_objects.schema);
    
    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    const [numOfNights, setNumOfNights] = useState(0);

    let [availabilityStatus, setAvilabilityStatus] = useState(null);
    const [roomAvailable, setRoomAvailable] = useState(false);

    /*let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    const [numOfNights, setNumOfNights] = useState(authenticatedMerchent_context.numOfNights);*/

    let [ bookingType, setBookingType ] = useState('online');
    //let [ checkInRoomID, setCheckInRoomID ] = useState(null);
    let [ roomSalePrice, setRoomSalePrice ] = useState(0.00);

    let [showRoomDisplay, setShowRoomDisplay] = useState('none');

    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [viewHotelRooms_showcase, setViewHotelRooms_showcase] = useState([]);

    let [disable_viewImages, setDisable_viewImages] = useState(true);

    let [ roomID, setRoomID ] = useState(null);
    let [ roomPic1, setRoomPic1 ] = useState(null);
    let [ roomPic2, setRoomPic2 ] = useState(null);
    let [ roomPic3, setRoomPic3 ] = useState(null);
    let [ roomPic4, setRoomPic4 ] = useState(null);

    const [inputClass_selectRoom, setInputClass_selectRoom] = useState('dateInput_text');

    let [isloading, setLoading] = useState(false);


    function getAvailableRooms(event)
    {

        setViewHotelRooms_showcase([]);

        if(props.openModal == true)
        {
            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {'content-type': 'application/json' },
                body: JSON.stringify({
                    Tracker: props.tracker,
                    user: acctID,
                    xCompanyID_public: props.data.companyID,
                    xStartDateRange: event[0],
                    xEndDateRange: event[1],
    
                }),
            }


            let newBaseURL = 'https://ghanaverified.com';
            if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
            {
                newBaseURL = 'https://ghanaverifiedtest.com'
            }

            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'ghanaverified/', requestOptions)
            .then(res => res.text())
            .then(res => {


            
                            let rows = res.toString().split('~~~');
    
                            let rowLength = rows.length;

                            /*if(rowLength > 1)
                            {
                                setRoomAvailable(true);
                                //document.getElementsByClassName('checkInDate')[0].style.backgroundColor ='rgb(111, 238, 132)';
                            }
                            else 
                            {
                                setRoomAvailable(false);
                
                                //document.getElementsByClassName('checkInDate')[0].style.backgroundColor ='rgb(245, 39, 80)';
                                //document.getElementById('searchAvailableRooms').innerHTML = '';
                    
                            }*/

                            //alert('In useEffect After Response');
                            //alert(rows);
                            //alert(rowLength);
                            //alert(roomAvailable);

                            //document.getElementById('searchAvailableRooms').innerHTML = '<option value = "0" selected=\'selected\'> Select </option>';

    
                                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                                {
                                    let cols = rows[rownum].split('|');

                                    if(rownum == 0)
                                    {
                                        let roomAttributes;

                                        if(cols[8] == 250.00)
                                        {
                                            roomAttributes = 'Fan & AC';
                                        }
                                        else
                                        {
                                            roomAttributes = 'Fan Only';
                                        }
                                        
                                        //document.getElementById('searchAvailableRooms').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+cols[0]+'\' data-cost=\''+cols[8]+'\' data-pic1=\''+cols[9]+'\' data-pic2=\''+cols[10]+'\' data-pic3=\''+cols[11]+'\' data-pic4=\''+cols[12]+'\' >Room '+cols[0]+':   GH₵ '+parseFloat(cols[8]).toFixed(2)+' '+roomAttributes+'</option>');

                                    }
                                    // else
                                    // {
                                    //     let roomAttributes;

                                    //     if(cols[8] == 250.00)
                                    //     {
                                    //         roomAttributes = 'Fan & AC';
                                    //     }
                                    //     else
                                    //     {
                                    //         roomAttributes = 'Fan Only';
                                    //     }

                                    //     //document.getElementById('searchAvailableRooms').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+cols[0]+'\' data-cost=\''+cols[8]+'\' data-pic1=\''+cols[9]+'\' data-pic2=\''+cols[10]+'\' data-pic3=\''+cols[11]+'\' data-pic4=\''+cols[12]+'\' >Room '+cols[0]+':   GH₵ '+parseFloat(cols[8]).toFixed(2)+' '+roomAttributes+'</option>');
                                    // }

                                    setViewHotelRooms_showcase((prevSetViewHotelRooms_showcase) => {
                                        return prevSetViewHotelRooms_showcase.concat({
                                            id: cols[0],
                                            cost: cols[8],
                                            pic1: cols[9],
                                            pic2: cols[10],
                                            pic3: cols[11],
                                            pic4: cols[12],
                                        })
                
                                    });
    
                                }

                                setLoading(false);

                            
                        }, 'html')
        }
    };

    function availableRoomDetails(event)
    {

        let selectBox = event.target; // Use event.target to get the IonSelect
        let selectedValue_id = selectBox.value; // Get the selected value (room ID)
        
        // Find the selected option to access custom attributes
        let selectedOption = Array.from(selectBox.children).find(option => option.value === selectedValue_id);
    

        if (selectedOption) {
            let selectedValue_cost = selectedOption.getAttribute('data-cost');
            let selectedValue_pic1 = selectedOption.getAttribute('data-pic1');
            let selectedValue_pic2 = selectedOption.getAttribute('data-pic2');
            let selectedValue_pic3 = selectedOption.getAttribute('data-pic3');
            let selectedValue_pic4 = selectedOption.getAttribute('data-pic4');
    
            setRoomID(selectedValue_id);
            setRoomPic1(selectedValue_pic1);
            setRoomPic2(selectedValue_pic2);
            setRoomPic3(selectedValue_pic3);
            setRoomPic4(selectedValue_pic4);

            setRoomSalePrice(selectedValue_cost);

            if(selectedValue_id != '' && selectedValue_id != null && selectedValue_id != undefined)
            {
                setDisable_viewImages(false);
            }
            else
            {
                setDisable_viewImages(true);
            }
    
            props.onCheckInRoomID({selectedRoomID: selectedValue_id, selectedBookingType: bookingType, selectedRoomSalesPrice: selectedValue_cost});

            setInputClass_selectRoom('dateInput_text');

        }

    }

    /*function closeModalHandler() {

        setViewInventoryBookedRooms([]);
        props.closeModal(false);
    }*/

    function enlargeImage()
    {
        //alert('Enlarge Image');
        //alert(document.getElementById('slideImages').style.width);

        if(document.getElementById('1').style.width == "100%" || document.getElementById('2').style.width == "100%" || document.getElementById('3').style.width == "100%" || document.getElementById('4').style.width == "100%")
        {
            document.getElementById('1').style.width = '150px';
            document.getElementById('1').style.height = '125px';
            document.getElementById('1').style.zIndex = 1;

            document.getElementById('2').style.width = '150px';
            document.getElementById('2').style.height = '125px';
            document.getElementById('2').style.zIndex = 1;

            document.getElementById('3').style.width = '150px';
            document.getElementById('3').style.height = '125px';
            document.getElementById('3').style.zIndex = 1;

            document.getElementById('4').style.width = '150px';
            document.getElementById('4').style.height = '125px';
            document.getElementById('4').style.zIndex = 1;
        }
        else
        {
            document.getElementById('1').style.width = "100%";
            document.getElementById('1').style.height = "100%";
            document.getElementById('1').style.zIndex = 9;

            document.getElementById('2').style.width = "100%";
            document.getElementById('2').style.height = "100%";
            document.getElementById('2').style.zIndex = 9;

            document.getElementById('3').style.width = "100%";
            document.getElementById('3').style.height = "100%";
            document.getElementById('3').style.zIndex = 9;

            document.getElementById('4').style.width = "100%";
            document.getElementById('4').style.height = "100%";
            document.getElementById('4').style.zIndex = 9;
        }


    }

    function onCheckInDateHandler(event) {

            setLoading(true);

            setStartDate(event.startDate);
            setEndDate(event.endDate);
            setNumOfNights(event.numOfNights);

            if(event.selectRoomColor == 'black')
            {
                setInputClass_selectRoom('dateInput_text');
            }
            if(event.selectRoomColor == 'red')
            {
                setInputClass_selectRoom('dateInput_text_red');
            }

            getAvailableRooms([event.startDate, event.endDate, event.numOfNights])
 

            props.onCheckInDate(event);

            const selectElement = document.getElementById('searchAvailableRooms');

            if (selectElement) {

                selectElement.value = selectElement.options[0].value;

                const changeEvent = new Event('change', { bubbles: true });

                selectElement.dispatchEvent(changeEvent);


            }
    
    }


    /*useEffect(() => {

        alert("In SelectRoom useEffect");
        alert(availabilityStatus);
        alert(roomAvailable);

        if(availabilityStatus == 'red' && roomAvailable == false)
        {
            alert('No Rooms Avaialable within these dates. Please re-enter dates.');

            document.getElementsByClassName('checkInDate')[0].style.backgroundColor ='rgb(245, 39, 80)';
            document.getElementsByClassName('checkOutDate')[0].style.backgroundColor ='rgb(245, 39, 80)';
        }
        else if(availabilityStatus == null && roomAvailable == true)
        {
            document.getElementsByClassName('checkInDate')[0].style.backgroundColor ='rgb(111, 238, 132)';
            document.getElementsByClassName('checkOutDate')[0].style.backgroundColor ='rgb(111, 238, 132)';
        }
    }, [roomAvailable])*/
    
    //alert('Inside select room');


    return (

        <React.Fragment>
            {props.openModal == true ?
            (        
                <React.Fragment>            
                    <IonGrid className='grid_checkInHeader'>

                        <SelectDateRange_CheckIn onCheckInDate={onCheckInDateHandler} closeModal={() =>props.closeModal()} data={{
                        companyID: props.data.companyID,
                        }}></SelectDateRange_CheckIn>

                        {/*<IonRow>
                            <IonCol className='checkInDate' size='6'>
                                <h3>CHECK-IN</h3>
                                <h6> {startDate} </h6>
                            </IonCol>
                            <IonCol className='checkOutDate' size='6'>
                                <h3>CHECK-OUT</h3>
                                <h6> {endDate} </h6>
                            </IonCol>
                        </IonRow>*/}

                        <IonRow>
                            <IonCol size='6'> Select Room</IonCol>
                            <IonCol size='6'> Nights</IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6' className={inputClass_selectRoom}>
                                <select id='searchAvailableRooms' className='selectRoom_dropdown_options' onChange={availableRoomDetails} required>
                                <option value="" disabled>Select a Room</option>
                                {viewHotelRooms_showcase.map(room => (
                                        <option 
                                            key={room.id} 
                                            value={room.id} 
                                            data-cost={room.cost} 
                                            data-pic1={room.pic1} 
                                            data-pic2={room.pic2} 
                                            data-pic3={room.pic3} 
                                            data-pic4={room.pic4}
                                        >
                                           Room - {room.id}
                                        </option>
                                    ))}
                                </select>
                            </IonCol>
                            <IonCol size='6'>  {numOfNights} </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton style={{ fontSize: "1.2em" }} onClick={() => setRoomPicsModal(true)} disabled={disable_viewImages} > View Images </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    
                   {/* <IonSlides pager='true' options={{direction: 'horizontal'}}>
                        { viewHotelRooms_showcase.map((detailData) =>   {
                            return (
                                    <IonSlide key={detailData.id}>
                                        <div className='grid_room_slides' id={detailData.id}>
                                            <IonImg src={detailData.image} style={{width: '100%', height: '100%'}} onClick={() => enlargeImage()}></IonImg>
                                        </div>
                                    </IonSlide>
                            );
                        })}
                    </IonSlides>*/}


                    {roomPicsModal == true && <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: roomPic1, 
                        roomPic2: roomPic2, 
                        roomPic3: roomPic3, 
                        roomPic4: roomPic4, 
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice
                        }}>
                    </ShowRoomPicsModal>}

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}

                    </React.Fragment>

            ) : null }
        </React.Fragment>
    )
}

/*<IonSlides pager='true' loop="true" options={{direction: 'horizontal'}}>
{ viewHotelRooms_showcase.map((detailData) =>   {
    return (
            <IonSlide key={detailData.id}>
                <IonImg src={detailData.image} style={{width: '150px', height: '125px'}}></IonImg>
            </IonSlide>
    );
})}
</IonSlides>
*/
/* { viewHotelRooms_showcase.map((detailData) =>   {
    return (

            <IonSlides id={detailData.id} pager='true' loop="true" options={{direction: 'horizontal'}}>
                <IonSlide >
                    <IonImg src={detailData.image1} style={{width: '150px', height: '125px'}}></IonImg>
                </IonSlide>
                <IonSlide >
                    <IonImg src={detailData.image2} style={{width: '150px', height: '125px'}}></IonImg>
                </IonSlide>
                <IonSlide >
                    <IonImg src={detailData.image3} style={{width: '150px', height: '125px'}}></IonImg>
                </IonSlide>
                <IonSlide >
                    <IonImg src={detailData.image4} style={{width: '150px', height: '125px'}}></IonImg>
                </IonSlide>
            </IonSlides>
    );
})}*/